export default "__VITE_ASSET__5391d2cf__"